import firebase from "firebase/app";
import "firebase/functions";
import firestore from "src/apiService/firestore";
import { getUserId } from "src/config/storage";
import { USER_PLAN as UserPlan } from "src/enums/common.enum";
import type { Cookie } from "src/utils/extension";

export async function whatnotIntegrationCreate(args: {
  cookies: Cookie[];
  integrationId?: string;
  username?: string;
  lastSync?: string;
  bankAccountId?: string;
  whatnotUserId: string;
  userAgent?: string;
}) {
  const f = firebase.functions().httpsCallable("whatNot-integrationCreate");
  const { whatnotUserId, userAgent = navigator.userAgent, ...rest } = args;
  if (!whatnotUserId) {
    throw new Error(
      "Unable to detect your Whatnot user ID. Please log out of Whatnot and log back in, then try again."
    );
  }
  return await f({
    ...rest,
    userId: whatnotUserId,
    userAgent,
  });
}

export async function whatnotIntegrationDelete(id: string): Promise<void> {
  const f = firebase.functions().httpsCallable("whatNot-deleteIntegration");
  await f({ integrationId: id });
}

export async function whatnotIntegrationSyncChange(
  id: string,
  sync: boolean,
  inventory: boolean = true
) {
  const userId = await getUserId();
  const db = firestore();

  await db.runTransaction(async (transaction) => {
    const user = await transaction.get(db.collection("Users").doc(userId));
    await transaction.update(db.collection("Plaid_Integrations").doc(id), {
      sync: sync && user.data()?.plan === UserPlan.ULTIMATE,
      inventory: sync && inventory,
    });
  });
}

export async function whatnotProcessFile(
  integrationId: string,
  type: "sales" | "transactions",
  importType: "initial-import" | "direct-import" | "daily-sync",
  filename: string,
  {
    uploadSalesId,
    uploadReturnsId,
    uploadTransactionsId,
  }: {
    uploadSalesId?: string;
    uploadReturnsId?: string;
    uploadTransactionsId?: string;
  } = {}
) {
  const f = firebase.functions().httpsCallable("whatNot-processFile");
  return await f({
    integrationId,
    importType,
    type,
    filename,
    uploadSalesId,
    uploadReturnsId,
    uploadTransactionsId,
  });
}

export async function getWhatnotIntegration() {
  const uid = await getUserId();
  const db = firestore();
  const integrations = await db
    .collection("Plaid_Integrations")
    .where("user", "==", uid)
    .where("type", "==", "what-not")
    .get();
  const integration = integrations.docs.pop();
  if (integration) {
    return integration.data();
  } else {
    return null;
  }
}
